import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import { addEventListener } from 'ThreeTerminal_base/base';
import { InformationFlow, QQShare, WxLaunchApp } from 'ThreeTerminal_mobile';
import { h5PageCount } from 'ThreeTerminal_utils';
import Grounds from 'ThreeTerminal_base/grounds';
import { callApp, getSchemeLink } from '@ifeng/callapp';
import worldArea from '../../data/worldMap/worldArea';
import { getAreaContent } from '../../services/api';
import SlidesTabs from './slidesTabs';
import Map from './map';
import Line from './line';
import Intro from './intro';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        data: {},
        areaContent: [],
        current: null,
        introShow: false,
        isExtraAll: false,
        isAll: false,
        tabShow: false,
        areaType: 'area',
        currentPath: 'maps',
        currentTab: '',
    };

    async componentDidMount() {
        const { areaCode } = this.state;
        const {
            content: { base62Id, devicetype },
        } = this.props;

        this.unHandleScroll = addEventListener(window, 'scroll', this.handleScroll);

        if (devicetype === 'share') {
            // 分享页统计
            h5PageCount([
                {
                    behavior: 'page',
                    type: 'topic',
                    other: {
                        id: `special_ucms_${base62Id}`,
                        url: encodeURIComponent(location.href),
                        ref: encodeURIComponent(document.referrer),
                    },
                },
            ]);
        } else if (devicetype === 'client') {
            Grounds.pageStat({
                id: `special_ucms_${base62Id}`,
                type: 'other',
                url: encodeURIComponent(location.href),
                ref: encodeURIComponent(document.referrer),
            });
        }

        const areaContent = await this.getAreaInfo();

        this.setState({
            data: { ...this.getListData(areaCode) },
            areaContent: [...areaContent],
        });
    }

    componentWillUnmount() {
        this.unHandleScroll();
    }

    // 兼容 ie7 的 offsetTop 获取方法
    getOffsetTop = id => {
        const dom = document.getElementById(`${id}`);
        const offsetTop = dom.offsetTop - 200;

        return offsetTop;
    };

    /**
     * 滚动条滚动
     */
    handleScroll = () => {
        // 兼容各主流浏览器
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        let currentPath = 'maps';
        let currentTab = '';

        if (currentTop > this.getOffsetTop('news')) {
            currentPath = 'news';
        }

        if (currentTop - 130 > this.getOffsetTop('news')) {
            currentTab = '';
        } else if (currentTop - 150 > this.getOffsetTop('list')) {
            currentTab = 'list';
        }

        this.setState({
            currentTab,
            currentPath,
            tabShow: currentTop > 100,
        });
    };

    getListData = () => {
        const {
            content: {
                yiqing_v2: { dataList, timestamp },
            },
        } = this.props;

        let result = {};

        try {
            const date = new Date(Number(timestamp));

            const Y = date.getFullYear();
            const M = date.getMonth() + 1;
            const D = date.getDate();
            const h = date.getHours();
            const m = date.getMinutes();

            const time = `截止 ${Y}.${M}.${D} ${h < 10 ? `0${h}` : h}:${m < 10 ? `0${m}` : m}`;

            const data = dataList;

            if (data) {
                const all = data.filter(item => item.name1 === '全国');

                const guowai = data.filter(item => item.name1 === '国外')[0];

                const list = guowai.child.sort((a, b) => {
                    const num1 = Number(a.quezhen);
                    const num2 = Number(b.quezhen);

                    return num2 - num1;
                });

                const quezhen_add = guowai.quezhen_add;
                let quezhen = 0;
                let zhiyu = 0;
                let siwang = 0;

                list.forEach(item => {
                    // quezhen_add += Number(item.quezhen_add && item.quezhen_add !== '待公布' ? item.quezhen_add : 0);
                    quezhen += isNaN(Number(item.quezhen)) ? 0 : Number(item.quezhen);
                    zhiyu += isNaN(Number(item.zhiyu)) ? 0 : Number(item.zhiyu);
                    siwang += isNaN(Number(item.siwang)) ? 0 : Number(item.siwang);

                    if (item.child) {
                        const unknow = item.child.filter(item => item.name2.indexOf('未明确') > -1);

                        item.child = item.child
                            .filter(item => item.name2.indexOf('未明确') === -1)
                            .sort((a, b) => {
                                const num1 = Number(a.quezhen);
                                const num2 = Number(b.quezhen);

                                return num2 - num1;
                            })
                            .concat(unknow);
                    }
                });

                const filterArr = Object.keys(worldArea);

                const ranking = list
                    .filter(item => filterArr.includes(item.name2))
                    .sort((a, b) => {
                        const num1 = Number(a.quezhen);
                        const num2 = Number(b.quezhen);

                        return num2 - num1;
                    })
                    .slice(0, 5);

                const areaData = {
                    quezhen_add,
                    quezhen,
                    zhiyu,
                    siwang,
                };

                result = {
                    time,
                    all,
                    list,
                    areaData,
                    ranking,
                };

                if (document.querySelector('#ifeng_share_title')) {
                    document.querySelector('#ifeng_share_title').innerText = `全球疫情地图：海外确诊超${Math.floor(
                        areaData.quezhen / 10000,
                    )}万 美国超${Math.floor(ranking.filter(item => item.name2 === '美国')[0].quezhen / 10000)}万`;
                }
            }
        } catch (error) {
            console.error(error);
        }

        return result;
    };

    getAreaInfo = async () => {
        let areaContent = await getAreaContent('world', '180164');

        areaContent = areaContent.map(item => ({
            url: item.url,
            title: item.title,
            base62Id: item.base62Id,
            type: item.type,
            source: item.source,
            searchPath: item.searchPath,
            skey: item.skey,
            commentUrl: item.commentUrl,
            newsTime: item.newsTime,
            newStyle: item.newStyle,
            thumbnail:
                item.thumbnails.image &&
                item.thumbnails.image.value &&
                item.thumbnails.image.value.length > 0 &&
                item.thumbnails.image.value[0].url,
            thumbnails: item.thumbnails.image.value,
        }));

        const url = window.location.href;

        if (url.indexOf('srctag') > -1 && areaContent.length > 0) {
            areaContent.forEach(item => {
                if (item.type === 'article') {
                    item.url = `https://c1.m.ifeng.com/ivivo?ch=ref_vivo_fyp1&type=doc&aid=ucms_${item.base62Id}&srctag=exp_national_0_1`;
                } else if (item.type === 'slide') {
                    item.url = `https://c1.m.ifeng.com/ivivo?ch=ref_vivo_fyp1&type=slide&aid=ucms_${item.base62Id}&srctag=exp_national_2_0`;
                } else if (item.type === 'video') {
                    item.url = `https://c1.ifeng.com/ivivo?ch=ref_vivo_fyp1&type=video&aid=${item.guid}`;
                } else if (item.type === 'special') {
                    item.url = item.url.replace('special', 'vivo');
                }
            });
        }

        return areaContent;
    };

    // 判断是否是微信
    isWeixin = () => {
        const ua = typeof navigator === 'object' ? navigator.userAgent : '';

        return ua.match(/MicroMessenger/gi);
    };

    // 判断是否是客户端
    isClient = () => {
        return window && typeof window.grounds !== 'undefined';
    };

    handleTabChange = currentPath => {
        this.setState({
            currentPath,
        });
    };

    handleDataTabChange = type => {
        this.setState({
            areaType: type,
        });
    };

    handleExtraShow = () => {
        const { isExtraAll } = this.state;

        this.setState({
            isExtraAll: !isExtraAll,
        });
    };

    handleTimeLineShow = () => {
        const { isAll } = this.state;

        this.setState({
            isAll: !isAll,
        });
    };

    handleIntroShow = () => {
        document.querySelector('html').style.overflow = 'hidden';
        document.querySelector('body').style.overflow = 'hidden';

        this.setState({
            introShow: true,
        });
    };

    handleMaskHide = e => {
        e.stopPropagation();

        if (e.target.id !== 'mask' && e.target.id !== 'close') {
            return;
        }

        document.querySelector('html').style.overflow = 'auto';
        document.querySelector('body').style.overflow = 'auto';

        this.setState({
            introShow: false,
        });
    };

    goBack = () => {
        window.history.back();
    };

    handleExpand = (index, name) => {
        if (Object.keys(worldArea).indexOf(name) === -1 || name === '钻石公主号') {
            return;
        }

        const { current } = this.state;

        this.setState(
            {
                current: index === current ? null : index,
            },
            () => {
                const dom = document.querySelectorAll('[data-expand]')[index];

                scrollTo(0, dom.offsetTop - 80);
            },
        );
    };

    getExpand = (index, child) => {
        const { current } = this.state;

        if (current === index) {
            return child ? (
                <div className={styles.expandtr_box}>
                    {child.map((item, k) => (
                        <div key={k} className={styles.expandtr}>
                            <span>{item.name3}</span>
                            <span>{item.quezhen_add || 0}</span>
                            <span>{item.quezhen || 0}</span>
                            <span>{item.zhiyu || 0}</span>
                            <span>{item.siwang || 0}</span>
                        </div>
                    ))}
                </div>
            ) : (
                <div className={styles.expandtr}>
                    <p>暂无统计数据</p>
                </div>
            );
        }

        return '';
    };

    handleClick = () => {
        const {
            content: { base62Id },
        } = this.props;

        h5PageCount([
            {
                behavior: 'action',
                type: 'topic',
                other: {
                    id: `special_ucms_${base62Id}`,
                    url: encodeURIComponent(location.href),
                    ref: encodeURIComponent(document.referrer),
                },
            },
        ]);

        const nodata = '';
        const doc_type = 'topic3';
        const aid = '7uJoU6xHs9I';
        const to_url = 'https://news.ifeng.com/c/special/7uJoU6xHs9I';
        const downloads = {
            download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1450306105889',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8791',
        };

        callApp({
            docType: doc_type,
            pid: aid,
            kind: 'inter_fxyzt02',
            download: downloads.download,
            downloadAd: downloads.downloadAd,
            noPrefixKind: true,
        });
    };

    getInfoUrl = code => {
        const {
            content: { devicetype },
        } = this.props;

        let url = '';

        if (devicetype === 'share') {
            url = `https://ishare.ifeng.com/c/s/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        } else if (devicetype === 'client') {
            url = `https://news.ifeng.com/c/specialClient/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        } else {
            url = `https://news.ifeng.com/c/special/7uLyp1412jw?code=${code}&needpage=1&webkit=1`;
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = `https://news.ifeng.com/c/vivo/7uLyp1412jw?code=${code}`;
        }

        return url;
    };

    getChinaUrl = () => {
        const {
            content: { devicetype },
        } = this.props;

        let url = '';

        if (devicetype === 'share') {
            url = 'https://ishare.ifeng.com/c/s/7tPlDSzDgVk?needpage=1&webkit=1';
        } else if (devicetype === 'client') {
            url = 'https://news.ifeng.com/c/specialClient/7tPlDSzDgVk?needpage=1&webkit=1';
        } else {
            url = 'https://news.ifeng.com/c/special/7tPlDSzDgVk?needpage=1&webkit=1';
        }

        if (window.location.href.indexOf('srctag') > -1) {
            url = 'https://news.ifeng.com/c/vivo/7tPlDSzDgVk';
        }

        return url;
    };

    handleLoadingDataFunc = () => {
        const { areaContent } = this.state;
        const content = areaContent.slice(15);

        return {
            content,
            isEnd: true,
            callback: () => {
                console.log('success');
            },
        };
    };

    render() {
        const {
            data,
            data: { time, all, list, areaData, ranking },
            areaContent,
            current,
            introShow,
            isExtraAll,
            tabShow,
            currentPath,
            currentTab,
        } = this.state;
        const {
            content,
            content: { worldAllDate, leiji },
        } = this.props;

        const tabs = [
            {
                title: '全球疫情',
                url: '#maps',
                searchPath: 'maps',
            },
            {
                title: '全球报道',
                url: '#news',
                searchPath: 'news',
            },
        ];

        const devicetype = content.devicetype;

        const isClient = this.isClient();

        let isCallup = devicetype !== 'pc' && !isClient;

        const url = window.location.href;

        let downloadShow = true;
        let isShowVivoReturnBotton = false;

        if (devicetype === 'pc' || isClient) {
            downloadShow = false;
        }

        if (url.indexOf('srctag') > -1) {
            isCallup = false;
            downloadShow = false;
            isShowVivoReturnBotton = true;
        }

        let qqShareCofig = {
            title: content.shareTitle,
            // img: content.shareThumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            img: 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: content.introduction || '',
            cb: () => {
                console.log('分享成功');
            },
        };

        if (all && areaData) {
            qqShareCofig = {
                ...qqShareCofig,
                title: `全球疫情地图：海外确诊超${Math.floor(areaData.quezhen / 10000)}万 美国超${Math.floor(
                    ranking.filter(item => item.name2 === '美国')[0].quezhen / 10000,
                )}万`,
            };
        }

        const schemeLink = getSchemeLink({
            docType: 'topic3',
            pid: '7uJoU6xHs9I',
            kind: 'inter_fxyzt02',
            noPrefixKind: true,
        });

        return (
            <div className={styles.layout}>
                {all && areaData && <QQShare content={qqShareCofig} />}
                {tabShow && devicetype !== 'pc' && (
                    <SlidesTabs
                        content={tabs}
                        currentPath={currentPath}
                        showShadow={currentTab === ''}
                        handleTabChange={this.handleTabChange}
                    />
                )}
                {devicetype !== 'pc' && (
                    <div className={currentTab === '' ? styles.hide_head : styles.fix_thead}>
                        <span>国家(地区)</span>
                        {/* <span>新增病例</span> */}
                        <span>累计确诊</span>
                        {/* <span>治愈</span> */}
                        <span>死亡</span>
                        {/* <span>疫情</span> */}
                    </div>
                )}
                <a id="maps" />
                <div className={styles.banner}>
                    <img
                        src="https://x0.ifengimg.com/ucms/2020_40/476094BD3C08666F1F2016D73443BCE6392ACB23_w1125_h483.png"
                        alt=""
                    />
                    {isCallup && (
                        <div className={styles.enter} onClick={this.handleClick}>
                            <span>关注更多实时疫情</span>
                            <span />
                            <WxLaunchApp
                                launchType={'app'}
                                launchAppClick={() => {}}
                                schemeLink={schemeLink}
                                launchAppFail={() => {}}
                            />
                        </div>
                    )}
                    <div className={styles.bottom_bar} />
                </div>
                <div className={styles.data_header}>
                    <div className={styles.tab_box}>
                        <div>全球疫情（中国以外）</div>
                        <a href={this.getChinaUrl()}>
                            <span>点击查看中国疫情</span>
                        </a>
                    </div>
                    {areaData && (
                        <div className={styles.area_box}>
                            {/* <div>
                                <span>{areaData.quezhen_add || 0}</span>
                                <span />
                            </div> */}
                            <div>
                                <span>{areaData.quezhen || 0}</span>
                                <span />
                            </div>
                            {/* <div>
                                <span>{areaData.zhiyu || 0}</span>
                                <span />
                            </div> */}
                            <div>
                                <span>{areaData.siwang | 0}</span>
                                <span />
                            </div>
                        </div>
                    )}
                    <div className={styles.time}>
                        <span>
                            <span>{time}</span>
                            <span>|</span>
                            <span onClick={this.handleIntroShow}>数据说明 </span>
                            <span onClick={this.handleIntroShow} />
                        </span>
                    </div>
                </div>
                {/* <div className={styles.city_box}>
                    {ranking &&
                        ranking.map(item => (
                            <a key={item.name2} href={this.getInfoUrl(worldArea[item.name2].code)}>
                                <span>{item.name2}</span>
                            </a>
                        ))}
                </div> */}
                {/* {all && list && <Map data={data} devicetype={devicetype} />} */}
                {leiji && <Line leiji={leiji.dataList} />}
                <div className={styles.title_box}>
                    <span>海外病例</span>
                    <span>{`共有${(list && list.length - 1) || ''}个国家(地区)存在确诊`}</span>
                </div>
                <div id="list" className={styles.data_box}>
                    <div className={styles.thead}>
                        <span>国家(地区)</span>
                        {/* <span>新增病例</span> */}
                        <span>累计确诊</span>
                        {/* <span>治愈</span> */}
                        <span>死亡</span>
                        {/* <span>疫情</span> */}
                    </div>
                    <div className={styles.tbody}>
                        {list &&
                            list.slice(0, isExtraAll ? list.length : 15).map((item, index) => (
                                /* eslint-disable no-confusing-arrow */
                                <Fragment key={index}>
                                    <div
                                        data-expand
                                        className={`${styles.tr} ${styles.current_tr} ${
                                            index === (isExtraAll ? list.length - 1 : 14) ? styles.last_tr : ''
                                        }`}>
                                        {/* {Object.keys(worldArea).indexOf(item.name2) > -1 &&
                                        item.name2 !== '钻石公主号' ? (
                                            <div className={styles.expand}>
                                                <img
                                                    className={current === index ? styles.unfold : styles.fold}
                                                    src="https://x0.ifengimg.com/ucms/2020_07/6DB12E34118DB38FBFFB02C2D4BD78BA8F5EF0CA_w30_h21.png"
                                                />
                                            </div>
                                        ) : (
                                            <div className={styles.expand} />
                                        )} */}
                                        <div className={styles.tr_list}>
                                            <span>{item.name2}</span>
                                            {/* <span>{item.quezhen_add || 0}</span> */}
                                            <span>{item.quezhen || 0}</span>
                                            {/* <span className={item.zhiyu ? styles.zhiyu : ''}>{item.zhiyu || 0}</span> */}
                                            <span className={item.siwang ? styles.siwang : ''}>{item.siwang || 0}</span>
                                            {/* {Object.keys(worldArea).indexOf(item.name2) > -1 &&
                                                worldArea[item.name2].code && (
                                                    <a href={this.getInfoUrl(worldArea[item.name2].code)} />
                                                )} */}
                                        </div>
                                    </div>
                                    {this.getExpand(index, item.child)}
                                </Fragment>
                                /* eslint-abled no-confusing-arrow */
                            ))}
                        <div className={styles.extraMore} onClick={this.handleExtraShow}>
                            <span>{isExtraAll ? '点击收起' : '查看更多'}</span>
                            <img
                                className={isExtraAll ? styles.all : styles.noAll}
                                src="https://x0.ifengimg.com/ucms/2020_06/B47A435EB8F1B6223FEFFEBFFB85C53E9982C0C6_w24_h24.png"
                            />
                        </div>
                    </div>
                </div>
                <a id="news" />
                <div className={styles.title_box3}>
                    <span>
                        <img
                            src="https://x0.ifengimg.com/ucms/2020_06/9959CC5BBF739399C3293019433E7441585D74E2_w45_h45.png"
                            alt=""
                        />
                        <span>全球报道</span>
                    </span>
                    {isCallup && (
                        <div className={styles.title_enter} onClick={this.handleClick}>
                            <span>查看更多报道</span>
                        </div>
                    )}
                </div>
                <div className={isCallup ? styles.info_box0 : styles.info_box1}>
                    {areaContent && areaContent.length > 0 && (
                        <InformationFlow
                            isDisplayLoadingMore={areaContent.length > 15}
                            content={areaContent.slice(0, 15)}
                            handleLoadingDataFunc={this.handleLoadingDataFunc}
                        />
                    )}
                    <img src="https://x0.ifengimg.com/ucms/2020_07/0B46330073E1B16C3A3ED106B46A77A4FC8E7908_w1125_h204.png" />
                </div>
                {downloadShow && (
                    <div className={styles.download}>
                        <a href={this.getChinaUrl()}>
                            <span>中国疫情地图</span>
                        </a>
                        <div onClick={this.handleClick}>
                            <span>全球疫情专题</span>
                            <WxLaunchApp
                                launchType={'app'}
                                launchAppClick={() => {}}
                                schemeLink={schemeLink}
                                launchAppFail={() => {}}
                            />
                        </div>
                    </div>
                )}
                {isShowVivoReturnBotton && (
                    <div className={styles.return_icon} onClick={this.goBack}>
                        返回
                    </div>
                )}
                {introShow && (
                    <div
                        id="mask"
                        className={styles.mask}
                        style={{ fontSize: document.body.style.fontSize }}
                        onClick={this.handleMaskHide}>
                        <Intro handleMaskHide={this.handleMaskHide} />
                    </div>
                )}
            </div>
        );
    }
}

export default errorBoundary(Layout);
